import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Results() {
  return <section className="py-20 bg-[#0B1426] relative overflow-hidden" data-id="element-207">
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-blue-900/10 to-transparent pointer-events-none" data-id="element-208"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-211">
            EL RESULTADO
          </h2>

          <div className="space-y-6 text-lg text-gray-300 mb-12 text-left bg-[#111827] p-8 rounded-2xl border border-gray-800" data-id="element-212">
            <p data-id="element-213">
              Entrás al lunes sabiendo que los informes de CUD de la semana
              tienen una base lista para completar.
            </p>
            <p data-id="element-214">
              Las consultas de seguimiento fluyen porque la familia trae datos,
              no relatos.
            </p>
            <p data-id="element-215">
              Los padres están tranquilos porque tienen una Hoja de Ruta y
              tareas concretas para casa.
            </p>

            <div className="pt-6 mt-6 border-t border-gray-800" data-id="element-216">
              <p className="font-bold text-yellow-500 mb-4 uppercase tracking-wider text-sm" data-id="element-217">
                Y lo más importante de todo:
              </p>
              <ul className="space-y-4 font-medium text-white text-xl" data-id="element-218">
                <li className="flex items-center gap-3" data-id="element-219">
                  <span className="text-yellow-500" data-id="element-220">→</span> Terminás tu jornada
                  y la jornada termina de verdad.
                </li>
                <li className="flex items-center gap-3" data-id="element-221">
                  <span className="text-yellow-500" data-id="element-222">→</span> Cerrás la
                  computadora el viernes y no la volvés a abrir hasta el lunes.
                </li>
                <li className="flex items-center gap-3" data-id="element-223">
                  <span className="text-yellow-500" data-id="element-224">→</span> Dejás de ser el
                  médico que trabaja gratis los domingos.
                </li>
                <li className="flex items-center gap-3 text-2xl text-yellow-400 mt-6" data-id="element-225">
                  <span className="text-yellow-500" data-id="element-226">→</span> Volvés a ser dueño
                  de tu tiempo.
                </li>
              </ul>
            </div>
          </div>

          <CTAButton text="QUIERO RECUPERAR MI TIEMPO →" data-id="element-227" />
        </motion.div>
      </div>
    </section>;
}